var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7193 3.01495C12.3401 3.11461 13.8597 3.91191 14.974 5.0082C16.2909 6.40347 17 8.09774 17 10.091C17 11.6856 16.3922 13.1805 15.3792 14.4761C14.3662 15.6721 12.9479 16.569 11.3271 16.868C9.7063 17.167 8.08547 16.9677 6.66725 16.1704C5.24903 15.3731 4.13472 14.1771 3.52691 12.6822C2.9191 11.1873 2.8178 9.49301 3.32431 7.99807C3.83081 6.40347 4.74253 5.10786 6.16075 4.2109C7.47766 3.31394 9.09849 2.91529 10.7193 3.01495ZM11.2258 15.8714C12.5427 15.5724 13.7584 14.8748 14.6701 13.7785C15.4805 12.6822 15.987 11.3866 15.8857 9.99132C15.8857 8.39672 15.2779 6.80212 14.1636 5.70584C13.1505 4.70921 11.9349 4.11124 10.5167 4.01157C9.19979 3.91191 7.78157 4.2109 6.66725 5.0082C5.55294 5.8055 4.74253 6.90179 4.33732 8.29706C3.93211 9.59267 3.93211 10.9879 4.53992 12.2836C5.14773 13.5792 6.05944 14.5758 7.27506 15.2734C8.49068 15.9711 9.9089 16.1704 11.2258 15.8714V15.8714Z",
    fill: "#2968C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33838 6.50278L13.6567 9.97103L8.33838 13.4791V6.50278ZM9.22477 11.8447L12.0572 9.97701L9.22477 8.12429V11.8437V11.8447Z",
    fill: "#2968C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBlue);
export default __webpack_public_path__ + "static/media/play-blue.8b9f6132ca6c43a2eb3dbbfc908a12ed.svg";
export { ForwardRef as ReactComponent };